import { render, staticRenderFns } from "./shopProductSwiper.vue?vue&type=template&id=0b63aada&scoped=true&"
import script from "./shopProductSwiper.vue?vue&type=script&lang=js&"
export * from "./shopProductSwiper.vue?vue&type=script&lang=js&"
import style0 from "./shopProductSwiper.vue?vue&type=style&index=0&id=0b63aada&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63aada",
  null
  
)

export default component.exports